import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAdminAuth } from '../context/AdminAuthContext';

const navItems = [
  { to: '/dashboard',    icon: 'fa-th-large',    label: 'Dashboard' },
  { to: '/users',        icon: 'fa-users',        label: 'Users' },
  { to: '/jobs',         icon: 'fa-briefcase',    label: 'Jobs' },
  { to: '/applications', icon: 'fa-file-alt',     label: 'Applications' },
  { to: '/contacts',     icon: 'fa-envelope',     label: 'Enquiries' },
];


export default function Sidebar() {
  const { admin, logoutAdmin } = useAdminAuth();
  const { pathname } = useLocation();

  return (
    <aside style={{ width: 240, minHeight: '100vh', background: '#0A1628', display: 'flex', flexDirection: 'column', position: 'fixed', left: 0, top: 0, zIndex: 100 }}>
      {/* Logo */}
      <div style={{ padding: '24px 20px', borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 36, height: 36, borderRadius: 10, background: '#0066FF', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16, color: '#fff' }}>
            <img
                src="/justhiringlogo.png"
                alt="JustHiring24"
                style={{
                  height: 50,
                  width: "auto",
                  objectFit: "contain",
                  borderRadius: "50%",
                }}
              />
          </div>
          <div>
            <div style={{ color: '#fff', fontWeight: 800, fontSize: 15, lineHeight: 1 }}>JustHiring24</div>
            <div style={{ color: '#60a5fa', fontSize: 11, fontWeight: 600 }}>Admin Panel</div>
          </div>
        </div>
      </div>

      {/* Nav */}
      <nav style={{ flex: 1, padding: '16px 12px' }}>
        {navItems.map((item) => {
          const active = pathname === item.to;
          return (
            <Link key={item.to} to={item.to} style={{
              display: 'flex', alignItems: 'center', gap: 12, padding: '11px 14px', borderRadius: 10, marginBottom: 4,
              textDecoration: 'none', fontWeight: 600, fontSize: 14, transition: 'all .2s',
              background: active ? '#0066FF' : 'transparent',
              color: active ? '#fff' : 'rgba(255,255,255,0.6)',
            }}>
              <i className={`fa ${item.icon}`} style={{ width: 18, textAlign: 'center' }}></i>
              {item.label}
            </Link>
          );
        })}
      </nav>

      {/* Admin Info + Logout */}
      <div style={{ padding: '16px 12px', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12, padding: '10px 14px', background: 'rgba(255,255,255,0.05)', borderRadius: 10 }}>
          <div style={{ width: 34, height: 34, borderRadius: '50%', background: '#0066FF', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 800, fontSize: 14, flexShrink: 0 }}>
            {admin?.name?.charAt(0).toUpperCase()}
          </div>
          <div style={{ overflow: 'hidden' }}>
            <div style={{ color: '#fff', fontWeight: 700, fontSize: 13, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{admin?.name}</div>
            <div style={{ color: 'rgba(255,255,255,0.4)', fontSize: 11 }}>Administrator</div>
          </div>
        </div>
        <button onClick={logoutAdmin} style={{ width: '100%', padding: '10px', borderRadius: 10, border: 'none', background: 'rgba(239,68,68,0.15)', color: '#ef4444', fontWeight: 600, fontSize: 13, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
          <i className="fa fa-sign-out-alt"></i> Logout
        </button>
      </div>
    </aside>
  );
}
